import React from 'react';
import { Link } from 'react-router-dom';
import { isEmpty } from 'lodash-es';
import { useStoreState } from 'store';

import { ChevronLeftIcon } from '../assets/icons';
import Logo from '../assets/images/logo.png';
import styles from './Header.module.css';

const Header = () => {
  const { pageTitle } = useStoreState((state) => state.globalUtils);
  return (
    <div className={styles.container}>
      {!isEmpty(pageTitle) ? (
        <>
          <Link className={styles.backIcon} to="/"><ChevronLeftIcon width={20} height={20} /></Link>
          <div className={styles.pageTitle}>{pageTitle}</div>
        </>
      ) : (
        <>
          <img className={styles.logo} src={Logo} alt="" />
          Punjab Jain Sangh - Indore
        </>
      )}
    </div>
  );
};

export default Header;
